import React from "react";
import { Calculator, Database, FileText, Presentation, Puzzle, Wrench } from "lucide-react";
import { useNavigate } from "react-router-dom";

const ToolsPage = () => {
  const navigate = useNavigate();

  return (
    <div className="mx-auto max-w-6xl space-y-6 py-6">
      <div>
        <div className="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white px-3 py-1 text-xs font-semibold uppercase tracking-wide text-slate-500">
          <Wrench className="h-3.5 w-3.5" />
          Outils Deepflow
        </div>
        <h1 className="mt-3 text-3xl font-semibold tracking-tight text-slate-950">Outils</h1>
      </div>

      <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3">
        <button
          type="button"
          onClick={() => navigate("/tools/guttenberg")}
          className="rounded-xl border border-slate-200 bg-white p-5 text-left shadow-sm transition hover:border-blue-200 hover:shadow"
        >
          <div className="flex items-center gap-3">
            <span className="inline-flex h-11 w-11 items-center justify-center rounded-lg bg-blue-50 text-blue-700">
              <FileText className="h-5 w-5" />
            </span>
            <div>
              <h2 className="text-lg font-semibold text-slate-950">Guttenberg</h2>
              <p className="text-sm text-slate-500">Generation de rapports techniques.</p>
            </div>
          </div>
        </button>
        <button
          type="button"
          onClick={() => navigate("/tools/knowledge")}
          className="rounded-xl border border-slate-200 bg-white p-5 text-left shadow-sm transition hover:border-blue-200 hover:shadow"
        >
          <div className="flex items-center gap-3">
            <span className="inline-flex h-11 w-11 items-center justify-center rounded-lg bg-emerald-50 text-emerald-700">
              <Database className="h-5 w-5" />
            </span>
            <div>
              <h2 className="text-lg font-semibold text-slate-950">Knowledge / RAG</h2>
              <p className="text-sm text-slate-500">Recherche et vectorisation par projet.</p>
            </div>
          </div>
        </button>
        <button
          type="button"
          onClick={() => navigate("/tools/offres")}
          className="rounded-xl border border-slate-200 bg-white p-5 text-left shadow-sm transition hover:border-blue-200 hover:shadow"
        >
          <div className="flex items-center gap-3">
            <span className="inline-flex h-11 w-11 items-center justify-center rounded-lg bg-amber-50 text-amber-700">
              <Calculator className="h-5 w-5" />
            </span>
            <div>
              <h2 className="text-lg font-semibold text-slate-950">Offres</h2>
              <p className="text-sm text-slate-500">Chiffrages, propositions en slides et fiches client.</p>
            </div>
          </div>
        </button>
        <button
          type="button"
          onClick={() => navigate("/tools/presentations")}
          className="rounded-xl border border-slate-200 bg-white p-5 text-left shadow-sm transition hover:border-blue-200 hover:shadow"
        >
          <div className="flex items-center gap-3">
            <span className="inline-flex h-11 w-11 items-center justify-center rounded-lg bg-blue-50 text-blue-700">
              <Presentation className="h-5 w-5" />
            </span>
            <div>
              <h2 className="text-lg font-semibold text-slate-950">Présentations</h2>
              <p className="text-sm text-slate-500">Présentations client au format des propositions, PDF tenu à jour sur le Drive.</p>
            </div>
          </div>
        </button>
        <button
          type="button"
          onClick={() => navigate("/tools/rapports")}
          className="rounded-xl border border-slate-200 bg-white p-5 text-left shadow-sm transition hover:border-blue-200 hover:shadow"
        >
          <div className="flex items-center gap-3">
            <span className="inline-flex h-11 w-11 items-center justify-center rounded-lg bg-blue-50 text-blue-700">
              <FileText className="h-5 w-5" />
            </span>
            <div>
              <h2 className="text-lg font-semibold text-slate-950">Rapports</h2>
              <p className="text-sm text-slate-500">Rapports client en A4, à la charte des présentations, PDF tenu à jour sur le Drive.</p>
            </div>
          </div>
        </button>
        <button
          type="button"
          onClick={() => navigate("/tools/focus-tech")}
          className="rounded-xl border border-slate-200 bg-white p-5 text-left shadow-sm transition hover:border-blue-200 hover:shadow"
        >
          <div className="flex items-center gap-3">
            <span className="inline-flex h-11 w-11 items-center justify-center rounded-lg bg-violet-50 text-violet-700">
              <Presentation className="h-5 w-5" />
            </span>
            <div>
              <h2 className="text-lg font-semibold text-slate-950">Focus tech</h2>
              <p className="text-sm text-slate-500">Présentations des tactiques : diapos HTML, jumeaux numériques 3D.</p>
            </div>
          </div>
        </button>
        <button
          type="button"
          onClick={() => navigate("/tools/extension")}
          className="rounded-xl border border-slate-200 bg-white p-5 text-left shadow-sm transition hover:border-blue-200 hover:shadow"
        >
          <div className="flex items-center gap-3">
            <span className="inline-flex h-11 w-11 items-center justify-center rounded-lg bg-violet-50 text-violet-700">
              <Puzzle className="h-5 w-5" />
            </span>
            <div>
              <h2 className="text-lg font-semibold text-slate-950">Extension Réunions</h2>
              <p className="text-sm text-slate-500">Enregistrer Meet et Teams dans Deepflow : télécharger et installer.</p>
            </div>
          </div>
        </button>
      </div>
    </div>
  );
};

export default ToolsPage;
